/**
 * SEO 配置 - models (ไทย)
 */

export default {
    veo_3_1: {
        title: 'Google Veo 3.1 | WeryAI',
        description: 'Experience Google Veo 3.1 on WeryAI. High-quality results.',
        keywords: 'Google Veo 3.1, AI, WeryAI',
    },
    veo_3: {
        title: 'veo 3 | WeryAI',
        description: 'Experience veo 3 on WeryAI. High-quality results.',
        keywords: 'veo_3, AI, WeryAI',
    },
    veo_3_fast: {
        title: 'veo 3 fast | WeryAI',
        description: 'Experience veo 3 fast on WeryAI. High-quality results.',
        keywords: 'veo_3_fast, AI, WeryAI',
    },
    sora_2: {
        title: 'OpenAI Sora 2 | เครื่องสร้างวิดีโอ AI ที่แม่นยำตามหลักฟิสิกส์ | WeryAI',
        description: 'สร้างวิดีโอ AI ที่สมจริงและแม่นยำตามหลักฟิสิกส์ด้วย OpenAI Sora 2 พร้อมเสียงที่ซิงโครไนซ์และความต่อเนื่องของเรื่องราวแบบหลายช็อต',
        keywords: 'Sora 2, OpenAI Sora, โมเดลวิดีโอ AI, วิดีโอสมจริง, WeryAI',
    },
    weryai_video_1: {
        title: 'WeryAI Video 1.0 | WeryAI',
        description: 'Experience WeryAI Video 1.0 on WeryAI.',
        keywords: 'WeryAI Video 1.0, AI, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2.0 | WeryAI',
        description: 'Experience WeryAI Image 2.0 on WeryAI.',
        keywords: 'WeryAI Image 2.0, AI, WeryAI',
    },
    image_grok_2: {
        title: 'Grok-2 | xAI | WeryAI',
        description: 'Experience Grok-2 by xAI on WeryAI.',
        keywords: 'Grok-2, xAI, AI, WeryAI',
    },
    kling_ai: {
        title: 'Kling 2.5 Turbo | เครื่องสร้างวิดีโอ AI ระดับภาพยนตร์ | WeryAI',
        description: 'Kling 2.5 Turbo สร้างวิดีโอ AI ระดับภาพยนตร์พร้อมการควบคุมเลนส์ขั้นสูง การแสดงออกทางอารมณ์ และการเคลื่อนไหวที่ลื่นไหล',
        keywords: 'Kling 2.5 Turbo, Kling AI, วิดีโอ AI ระดับภาพยนตร์, การควบคุมเลนส์, WeryAI',
    },
    runway_ai: {
        title: 'Runway Gen-4 - เครื่องมือสร้างและตัดต่อวิดีโอ AI ขั้นสูง | WeryAI',
        description: 'Runway Gen-4 สร้างวิดีโอ AI ที่สมจริงและสม่ำเสมอ พร้อมการเข้าใจพรอมป์ต์เชิงลึกและเครื่องมือตัดต่ออัจฉริยะ ลองใช้ฟรีบน WeryAI',
        keywords: 'Runway Gen-4, Runway AI, ตัวสร้างวิดีโอ AI, ข้อความเป็นวิดีโอ, ภาพเป็นวิดีโอ, ตัดต่อวิดีโอ AI, WeryAI',
    },
    hailuo_23: {
        title: 'hailuo 23 | WeryAI',
        description: 'Experience hailuo 23 on WeryAI. High-quality results.',
        keywords: 'hailuo_23, AI, WeryAI',
    },
    hailuo_ai: {
        title: 'Hailuo AI Video Generator - การสร้างวิดีโอขั้นสูง | WeryAI',
        description: 'สร้างวิดีโอ AI ขั้นสูงด้วย Hailuo AI บน WeryAI มาพร้อมการควบคุมการเคลื่อนไหวระดับแนวหน้าและการเรนเดอร์ฉากที่สมจริง',
        keywords: 'Hailuo AI, MiniMax, เครื่องสร้างวิดีโอ AI, การควบคุมการเคลื่อนไหว, WeryAI',
    },
    pika_2_2: {
        title: 'pika 2 2 | WeryAI',
        description: 'Experience pika 2 2 on WeryAI. High-quality results.',
        keywords: 'pika_2_2, AI, WeryAI',
    },
    seedance: {
        title: 'เครื่องมือสร้างวิดีโอ Seedance AI - การสร้างท่าเต้นและท่าทาง | WeryAI',
        description: 'เครื่องมือสร้างวิดีโอ Seedance AI - การสร้างท่าเต้นและท่าทาง on WeryAI. Realistic and professional results.',
        keywords: 'seedance, AI, WeryAI',
    },
    image_nano_banana_pro: {
        title: 'Nano Banana Pro - การสร้างภาพ AI Google Gemini 3.0 Pro | WeryAI',
        description: 'Nano Banana Pro - การสร้างภาพ AI Google Gemini 3.0 Pro on WeryAI. Fast and high-quality results.',
        keywords: 'nano_banana_pro, AI, WeryAI',
    },
    image_nano_banana: {
        title: 'Google Nano Banana - การวาดภาพความเร็วสูง Gemini 2.5 Flash | WeryAI',
        description: 'Google Nano Banana - การวาดภาพความเร็วสูง Gemini 2.5 Flash on WeryAI. Fast and high-quality results.',
        keywords: 'nano_banana, AI, WeryAI',
    },
    image_flux: {
        title: 'เครื่องมือสร้างภาพ FLUX AI - โมเดลการวาดภาพโอเพนซอร์สชั้นนำ | WeryAI',
        description: 'เครื่องมือสร้างภาพ FLUX AI - โมเดลการวาดภาพโอเพนซอร์สชั้นนำ on WeryAI. Fast and high-quality results.',
        keywords: 'flux, AI, WeryAI',
    },
    image_flux_kontext: {
        title: 'FLUX.1 Kontext - การเพิ่มประสิทธิภาพการวาดภาพ AI ระดับมืออาชีพ | WeryAI',
        description: 'FLUX.1 Kontext - การเพิ่มประสิทธิภาพการวาดภาพ AI ระดับมืออาชีพ on WeryAI. Fast and high-quality results.',
        keywords: 'flux_kontext, AI, WeryAI',
    },
    image_imagen: {
        title: 'Google Imagen 4 - โมเดลการแพร่กระจายข้อความเป็นภาพขั้นสูงของ Google | WeryAI',
        description: 'Google Imagen 4 - โมเดลการแพร่กระจายข้อความเป็นภาพขั้นสูงของ Google on WeryAI. Fast and high-quality results.',
        keywords: 'imagen, AI, WeryAI',
    },
    image_qwen_image: {
        title: 'Qwen Image - โมเดลการแสดงผลข้อความโอเพนซอร์สของ Alibaba | WeryAI',
        description: 'Qwen Image - โมเดลการแสดงผลข้อความโอเพนซอร์สของ Alibaba on WeryAI. Fast and high-quality results.',
        keywords: 'qwen_image, AI, WeryAI',
    },
    image_wan_ai: {
        title: 'การสร้างภาพ Wan 2.5 - โมเดลภาพความเที่ยงตรงสูงของ Alibaba | WeryAI',
        description: 'การสร้างภาพ Wan 2.5 - โมเดลภาพความเที่ยงตรงสูงของ Alibaba on WeryAI. Fast and high-quality results.',
        keywords: 'wan_ai, AI, WeryAI',
    },
    image_seendream: {
        title: 'Seedream 4.0 - โมเดลการวาดภาพ 4K แบบกลุ่มของ ByteDance | WeryAI',
        description: 'Seedream 4.0 - โมเดลการวาดภาพ 4K แบบกลุ่มของ ByteDance on WeryAI. Fast and high-quality results.',
        keywords: 'seendream, AI, WeryAI',
    },
    image_dreamina: {
        title: 'Dreamina 4.0 - โมเดลการสร้างภาพ AI แบบครบวงจรของ ByteDance | WeryAI',
        description: 'Dreamina 4.0 - โมเดลการสร้างภาพ AI แบบครบวงจรของ ByteDance on WeryAI. Fast and high-quality results.',
        keywords: 'dreamina, AI, WeryAI',
    },
    image_seedream_4_5: {
        title: 'Seedream 4.5 - โมเดลสร้างภาพ AI ชั้นนำของ ByteDance | WeryAI',
        description: 'Seedream 4.5 เป็นโมเดลภาพ AI ชั้นนำล่าสุดของ ByteDance เน้นการเรนเดอร์ตัวอักษรที่แม่นยำและการรวมหลายภาพพร้อมเอาต์พุต 4K Ultra HD ทดลองใช้ฟรีบน WeryAI',
        keywords: 'Seedream 4.5, การสร้างภาพ AI, การเรนเดอร์ตัวอักษร, การรวมภาพ, ByteDance, คุณภาพ 4K, WeryAI',
    },
    image_midjourney: {
        title: 'Midjourney - การวาดภาพ AI สุนทรียศาสตร์ทางศิลปะชั้นนำ | WeryAI',
        description: 'Midjourney - การวาดภาพ AI สุนทรียศาสตร์ทางศิลปะชั้นนำ on WeryAI. Fast and high-quality results.',
        keywords: 'midjourney, AI, WeryAI',
    },
    runway_4_5: {
        title: 'Runway Gen-4.5 เครื่องมือสร้างวิดีโอ AI - สร้างวิดีโอระดับภาพยนตร์ | WeryAI',
        description: 'สร้างวิดีโอที่น่าทึ่งด้วย Runway Gen-4.5 บน WeryAI สถาปัตยกรรมไฮบริดออโตรีเกรสซีฟ-ดิฟฟิวชันสำหรับการจำลองฟิสิกส์ที่แม่นยำและความสอดคล้องทางเวลา',
        keywords: 'Runway Gen-4.5, เครื่องมือสร้างวิดีโอ AI, วิดีโอ AI ระดับภาพยนตร์, การจำลองฟิสิกส์, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Kling 2.6 Pro เครื่องมือสร้างวิดีโอ AI - สร้างวิดีโอคุณภาพสูง | WeryAI',
        description: 'สร้างวิดีโอคุณภาพสูงด้วย Kling 2.6 Pro บน WeryAI การสร้างเสียงและภาพดั้งเดิม คุณภาพภาพยนตร์ 1080p การปฏิบัติตามพรอมต์ที่ยอดเยี่ยม',
        keywords: 'Kling 2.6 Pro, เครื่องมือสร้างวิดีโอ AI, วิดีโอ AI คุณภาพสูง, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Dreamina 3.0 เครื่องมือสร้างวิดีโอ - การควบคุมกล้องที่แม่นยำและการนำทางเฟรม | WeryAI',
        description: 'สร้างวิดีโอ AI ระดับภาพยนตร์ด้วย Dreamina 3.0 (Jimeng 3.0) บน WeryAI การควบคุมเฟรมเริ่มต้น/สิ้นสุดที่แม่นยำ การเคลื่อนไหวกล้องระดับมืออาชีพ และการสร้างวิดีโอ 1080p ไดนามิกสูง',
        keywords: 'Dreamina 3.0, Jimeng Video 3.0, เครื่องมือสร้างวิดีโอ AI, การควบคุมกล้อง, เฟรมเริ่มต้นสิ้นสุด, ByteDance AI, WeryAI',
    },
    kling_o1: {
        title: 'Kling O1 เครื่องมือสร้างวิดีโอ AI - การสร้างวิดีโอสร้างสรรค์ | WeryAI',
        description: 'ปลดปล่อยความคิดสร้างสรรค์ของคุณบน WeryAI ด้วยเครื่องมือสร้างวิดีโอ AI Kling O1 เหมาะสำหรับการสร้างเนื้อหาวิดีโอที่มีจินตนาการและไม่ซ้ำใคร',
        keywords: 'Kling O1, เครื่องมือสร้างวิดีโอ AI, วิดีโอ AI สร้างสรรค์, Kling AI, WeryAI',
    },
}
